import React from 'react';
import { Button, Input, InputGroup, InputGroupText, Label } from 'reactstrap';
import { TFunction } from 'i18next';
import { useEffect, useState } from 'react';
import { getShopInfosInStorage } from 'tunnel-commande/src/components/cart/ShopInfos';

interface DimensionsFormProps {
    height: number;
    width: number;
    ratio?: number;
    surface: number;
    traduction: TFunction;
    onSendDimensions: (largeur: number, hauteur: number) => void;
    canUpdateDimensions?: CanUpdateDimensions;
    surfaceMin: number;
    onUpdate?: (isModified: boolean) => void;
}

export interface CanUpdateDimensions {
    disabled: boolean;
    display: boolean;
    active: boolean;
}

type TypeDimension = 'height' | 'width';

export const DimensionsForm = (props: DimensionsFormProps) => {
    const [largeur, setLargeur] = useState<string>(props.width.toString());
    const [hauteur, setHauteur] = useState<string>(props.height.toString());
    const ratio = props.ratio ?? 1;
    const [surface, setSurface] = useState<number>(props.surface);
    const [isModified, setIsModified] = useState<boolean>(false);

    const dimensionsValides = getShopInfosInStorage()?.dimensionsVisuel || {};

    function updateInput(type: TypeDimension, value: string) {
        let newValue = value.replace(',', '.');
        if(type === "width") {
            if(Number(newValue) < 0) {
                newValue = dimensionsValides.centimetreMinLargeur;
            }
            setLargeur(newValue);
            const newHauteur = Number((Number(newValue) / Number(ratio)));
            setHauteur(newHauteur.toFixed(2));
        } else if(type === "height") {
            if(Number(newValue) < 0) {
                newValue = dimensionsValides.centimetreMinHauteur;
            }
            setHauteur(newValue);
            const newLargeur = Number((Number(newValue) * Number(ratio)));
            setLargeur(newLargeur.toFixed(2));
        }
        
    }

    useEffect(() => {
        const surface = Number(largeur) * Number(hauteur);
        setSurface(Number(surface.toFixed(2)));
        setIsModified(props.width !== Number(largeur) && props.height !== Number(hauteur));
    }, [largeur, hauteur]);

    useEffect(() => props.onUpdate?.(isModified), [isModified]);

    function onSubmitBtn() {
        setIsModified(false);
        props.onSendDimensions(Number(largeur), Number(hauteur));
    }

    const renderBlocInput = (type: TypeDimension, value: string) => {
        let minDim = type === "width" ? dimensionsValides.centimetreMinLargeur : dimensionsValides.centimetreMinHauteur;
        minDim = String(minDim).replace('.', ',');
        return (
            <div>
                <Label className='lightgrey small mb0'>{props.traduction(type)}</Label>
                <InputGroup className='flex-nowrap'>
                    <Input bsSize="lg" className='border-dark input-dt-cmd px-0 h40px' type="number" style={{width: 100}} min={minDim} value={value} onChange={(event: React.ChangeEvent<HTMLInputElement>) => updateInput(type, event.target.value)} />
                    <InputGroupText className='input-dt-cmd h40px'>
                        cm
                    </InputGroupText>
                </InputGroup>
            </div>
        );
    }

    let errorClass = "red";
    let errorMessage = "";
    let classBtn = "btn-dt-secondary"
    const surfaceMax = dimensionsValides.centimetreMaxLargeur * dimensionsValides.centimetreMaxHauteur;
    let displayBtn = false;
    let disabledBtn = true;
    if((surface < props.surfaceMin || surface > surfaceMax) || (props.surface < props.surfaceMin || props.surface > surfaceMax)) {
        classBtn = "btn-dt-primary";
        displayBtn = true;
        if(surface < props.surfaceMin || surface > surfaceMax) {
            errorMessage = surface < props.surfaceMin ? `${props.surfaceMin} cm² minimum` : `${surfaceMax} cm² maximum`;
        }
    }

    if(largeur > dimensionsValides.centimetreMaxHauteur || hauteur > dimensionsValides.centimetreMaxHauteur) {
        errorMessage = `${dimensionsValides.centimetreMaxHauteur} cm maximum`;
    } else if((largeur > dimensionsValides.centimetreMaxLargeur) && (hauteur > dimensionsValides.centimetreMaxLargeur))  {
        errorMessage = `${props.traduction('maximum_dimensions')
                        .replace('CMM',dimensionsValides.centimetreMaxLargeur)
                        .replace('CML',dimensionsValides.centimetreMaxHauteur)}`;
    } else if((largeur < dimensionsValides.centimetreMinLargeur) || (hauteur < dimensionsValides.centimetreMinHauteur))  {
        errorMessage = `${props.traduction('required_dimensions_min')
                        .replace('CMinL',dimensionsValides.centimetreMinLargeur)}`;
    }

    if (errorMessage.length === 0) {
        errorClass = "";
        disabledBtn = false;
    }

    if(isModified) {
        displayBtn = true;
    }

    const strSurface = surface.toString().replace('.', ',');

    return (
        <div className="d-block d-lg-flex flex-column">
            <div className="d-flex justify-content-between  align-items-center flex-grow-1 ml-lg-2">
                <div className='d-block d-md-flex flex-grow-1 align-items-end flex-wrap justify-content-center justify-content-lg-start'>
                    <div className="d-flex flex-column  position-relative">
                        <div className="d-flex px-lg-2  justify-content-center justify-content-lg-start">
                            {renderBlocInput("width", largeur)}
                            <div className='px-2 font20 align-self-end'>
                                x
                            </div>
                            {renderBlocInput("height", hauteur)}
                        </div>

                        <div className='surfaceTotale py-2 py-lg-0'>
                            {errorMessage ? (
                                <span className={`${errorClass} small pl-1`}>{errorMessage}</span>
                            ) : (
                                <span title={props.traduction("area")} className={`mb0 text-center ${surface > surfaceMax || surface < props.surfaceMin ? 'small lightgrey' : ' small opac60'}`}>{strSurface} cm²</span>
                            )}
                        </div>
                    </div>
                    <div className='ml-lg-2 ml-md-0 align-self-end btnModifierDimensions flex-grow-1 flex-lg-grow-0'>
                        <Button disabled={disabledBtn || !displayBtn} block className={`w100 ${classBtn} py-0 h40px ${!displayBtn && 'border-0'}`}  onClick={onSubmitBtn}>{props.traduction('change')}</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}